(function($){

// ---------- APP START
window.App = {

  config: {
    scrollOffset: 70
  },

  init: function(){
		
		/* Init functions
		----------------------------------*/			
		if($('.warranty-us').length) App.warranty.initContract();
  },
	
	warranty: {
		
		initContract: function(){
			/* Toggle motor fields
			----------------------------------*/	
			$('.toggle--view').each(function () {
			 var $bloc = $(this);
			 var $trigger = "#" + $(this).data('trigger');
			 
			 $($trigger).on('change', function(e) {
				 if(
				 	($(this).attr('id') == 'motortype_st' && $(this).val() > 0) || 
				 	($(this).attr('id') == 'buyertype' && $(this).val() > 1)
				 ) {
					 $bloc.addClass('active');
				 }
				 else {
					 $bloc.removeClass('active'); 
				 }				 
			 });			 
			});
			
			/* Ajax pre-fill boat selects
			----------------------------------*/
			var $boatrange = $('#boatrange');
			var $boatmodel = $('#boatmodel');
			var $lang 		 = $('html').attr('lang');
			
			$('#boatbrand').on('change', function(e){
				var $brand = $(this).val();
					  $boatmodel.empty();
				$.ajax({
					url: '/' + $lang + '/ajax/brand/' + $brand,
					success: function(response) {
						$boatrange.html(response);
					}
				});	
			});
			
			$boatrange.on('change', function(e){
				var $brand 	 = $('#boatbrand').val();
				var $rangeid = $('#boatrange').val();
				$.ajax({
					url: '/' + $lang + '/ajax/brand/' + $brand + '/range/' + $rangeid,
					success: function(response) {
						$boatmodel.html(response);
					}
				});
			});
		}		
	}
};
// ---------- APP END

// Init app
// App.initTAC();
$(document).ready(App.init);
})(jQuery);


/*var language = 'fr';
window.addEvent('domready', function() {
	
	$$('.autosubmit').addEvent('change', function(e) {
		this.getParent('form').submit();
	});
	
	if($('warranty-step1')) {
		$('send').addEvent('click', function(e) {
			this.getParent('form').submit();
		});			
		warrantyInit1();
	}
	if($('warranty-step2')) {		
		$('send').addEvent('click', function(e) {
			this.getParent('form').submit();
		});			
		//warrantyInit2();
	}
});


// gestion cadre garantie
var frm,motortype,seltype,clicowner,boatbrand,boatrange,boatmodel;
var warrantyInit1 = function() {
	language = $(document).getElement('html').getProperty('lang');
	frm = $('warranty-step1');
	motortype = $('motortype_st') || null;
	seltype = $('buyertype') || null;
	clicowner = $$('.zodiacowner') || null;
	boatbrand = $('boatbrand');
	boatrange = $('boatrange');
	boatmodel = $('boatmodel');
	
	motortype.addEvent('change', function(e){
		toggleMotor();
	});
	seltype.addEvent('change', function(e){
		toggleCompany();		
	});
	clicowner.each(function(el) {el.addEvent('click',function(){
		toggleOwner();
		});
	});
	boatbrand.addEvent('change', function(e){
		setRanges();		
	});
	boatrange.addEvent('change', function(e){
		setModels();		
	});
	
	//toggleCompany();
	toggleMotor();
	//toggleOwner();
}
var toggleMotor = function() {
	var id = motortype.get('value');
	id = (id==''||id=='0'||id=='3')?'none':'block';
	$('motorbrand').setStyle('display',id);
}
var toggleCompany = function() {
	if($('company')) {
		var id = seltype.get('value');
		id = (id<2)?'none':'block';
		$('company').setStyle('display',id);
	}
}
var toggleOwner = function() {
	if($('zodiactype')) {
		var id = wCheckOwner();
		id = (id==1)?'block':'none';
		$('zodiactype').setStyle('display',id);
	}
}
var wCheckOwner = function() {
	el = frm.getElement("input[name=zodiac_owner]:checked");
	if(null !== el)
		return el.value;
	else 
		return null;
}
var setRanges = function() {
	var brand = boatbrand.get('value').toLowerCase();
	boatmodel.empty();
	new Request({
		url: '/'+language+'/ajax/brand/' + brand,
			onSuccess: function(response) {
				boatrange.set('html',response);
			}
	}).send();
}
var setModels = function() {
	var brand = boatbrand.get('value').toLowerCase();
	var rangeid = boatrange.get('value').toLowerCase();
	new Request({
		url: '/'+language+'/ajax/brand/' + brand + '/range/' + rangeid,
			onSuccess: function(response) {
				boatmodel.set('html',response);
			}
	}).send();
}
var codeCheck = function(period) {
	var warrantyid = $('warrantyid').value;
	var warcode = $('warcode');
	var warrate = $('warrate');
	var url = '/'+language+'/wfrontend/warranty/check/id/' + warrantyid + '/period/' + period;	
	new Request({
		url: url,
	    onSuccess: function(response) {
		var obj = JSON.decode(response);
			warcode.set('value',obj.code);
			warrate.set('value',obj.tarif);
	    }
	}).send();	
}*/